module.exports = __webpack_public_path__ + "img/ic-trash-can.e6ea11ec.svg";